import React from 'react';
import Banner from '../components/Banner';
import Breadcrumb from '../components/Breadcrumb';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import '../styles/pages/Industries.css';
import { Link } from "react-router-dom";

/* SWIPER */
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import IndustryBg from '../images/industry-bg.png'
/* IMAGES */
import tech from "../images/industries/technology.jpg";
import healthcare from "../images/industries/healthcare.jpg";
import finance from "../images/industries/finance.jpg";
import retail from "../images/industries/retail.jpg";
import education from "../images/industries/education.jpg";
import manufacturing from "../images/industries/industries.jpg";


import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";
import Testimonials from '../components/Testimonials';

/* ---------------- CARD COMPONENT ---------------- */
const IndustryCard = ({ item }) => (
    <div className="ind-card">
        <img src={item.img} alt={item.title} />
        <div className="grid-overlay"></div>

        <div className="industry-content">
            <h4>{item.title}</h4>
        </div>
    </div>
);


const Industries = () => {

    const industries = [
        { title: "TECHNOLOGY", img: tech, link: "/industries/technology" },
        { title: "HEALTHCARE", img: healthcare, link: "/industries/healthcare" },
        { title: "FINANCE", img: finance, link: "/industries/finance" },
        { title: "RETAIL & E-COMMERCE", img: retail, link: "/industries/retail" },
        { title: "EDUCATION", img: education, link: "/industries/education" },
        { title: "MANUFACTURING", img: manufacturing, link: "/industries/manufacturing" },
    ];
    const offices = [
        {
            icon: <FiMapPin />,
            title: "USA OFFICE",
            content: [
                "5717 Legacy Drive, Suite 250",
                " Plano, Texas, 75024,",
                "United States of America - USA"
            ]
        },
        {
            icon: <FiMapPin />,
            title: "UK OFFICE",
            content: [
                "FORTUNE CLOUD SOLUTIONS LTD",
                "2nd Floor College House 17 King Edwards Road,",
                "RUISLIP, London, HA4 7AE- UNITED KINGDOM"
            ]
        },
        {
            icon: <FiMapPin />,
            title: "CANADA OFFICE",
            content: [
                "Fortune Cloud Solutions INC",
                "Canada"
            ]
        },
        {
            icon: <FiMapPin />,
            title: "HYDERABAD OFFICE",
            content: [
                "Fortune Cloud Solutions LLC,",
                "Level 2, Oval Building Plot no.18, iLabs,",
                "Hyderabad Technology Park,",
                "Hyderabad 500081"
            ]
        },

        {
            icon: <FiMail />,
            title: "CONTACT US",
            content: [
                // { type: "email", value: "careers@fcsglobal.us" },
                { type: "email", value: "info@fcsglobal.us" },
                { type: "phone", value: "(+1) 2543 900 006" }
            ]
        }
    ];

    /* ---------------- ANIMATIONS ---------------- */

    // Header stagger
    const industryHeader = {
        hidden: {},
        show: { transition: { staggerChildren: 0.18 } }
    };

    const industryItem = {
        hidden: { opacity: 0, y: 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] }
        }
    };

    // Section reveal
    const sectionReveal = {
        hidden: { opacity: 0, y: 60 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] }
        }
    };

    // Cards stagger
    const gridContainer = {
        hidden: {},
        show: { transition: { staggerChildren: 0.12 } }
    };

    const gridItem = {
        hidden: { opacity: 0, y: 40, scale: 0.96 },
        show: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: { duration: 0.55, ease: "easeOut" }
        }
    };

    const container = {
        hidden: {},
        show: {
            transition: { staggerChildren: 0.2 }
        }
    };

    const item = {
        hidden: { opacity: 0, y: 50 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <SEO title="Industries" description="Industries We Serve - Fortune Cloud Solutions" />
            <section className="industries-main">
                <Banner title="SECTORS WE SERVE" image={IndustryBg} />

                <Breadcrumb />

                {/* BACKGROUND WRAPPER */}


                <motion.section
                    className="industries-section container pb-5"
                    variants={sectionReveal}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                >

                    {/* HEADER */}
                    <motion.div
                        className="industries-purple-header mb-4 text-purple"
                        variants={industryHeader}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, margin: "-80px" }}
                    >
                        <motion.span variants={industryItem} className="industries-badge">
                            EXPERTISE
                        </motion.span>

                        <motion.h2 variants={industryItem}>
                            DIVERSE SECTOR <br />EXPERTISE, TAILORED IT SOLUTIONS.
                        </motion.h2>
                    </motion.div>


                    {/* DESKTOP GRID */}
                    <motion.div
                        className="row g-4 industries-grid d-none d-lg-flex"
                        variants={gridContainer}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, margin: "-120px" }}
                    >
                        {industries.map((item, i) => (
                            <motion.div
                                className="col-lg-4 col-md-6"
                                key={i}
                                variants={gridItem}
                                whileHover={{ y: -8 }}
                            >
                                <Link to={item.link} className="industry-link">
                                    <IndustryCard item={item} />
                                </Link>
                            </motion.div>
                        ))}
                    </motion.div>


                    {/* MOBILE / TABLET SLIDER */}
                    <motion.div
                        className="industries-slider"
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, margin: "-120px" }}
                        variants={gridContainer}
                    >
                        <Swiper
                            modules={[Pagination, Autoplay]}
                            spaceBetween={20}
                            loop={true}
                            speed={800}
                            pagination={{ clickable: true }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true
                            }}
                            breakpoints={{
                                0: { slidesPerView: 1.2 },
                                576: { slidesPerView: 1.2 },
                                768: { slidesPerView: 2.4 },
                            }}
                        >
                            {industries.map((item, i) => (
                                <SwiperSlide key={i}>
                                    <Link to={item.link} className="industry-link">
                                        <IndustryCard item={item} />
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </motion.div>

                </motion.section>

                {/* Testimonial */}
                {/* <Testimonials /> */}
            </section>

        </motion.div>
    );
};

export default Industries;
